window.KlarnaOnsiteService = window.KlarnaOnsiteService || [];
window.KlarnaOnsiteService.push({ eventName: 'refresh-placements' });

var getUrlParameter = function getUrlParameter(sParam) {
    var sPageURL = window.location.search.substring(1),
        sURLVariables = sPageURL.split('&'),
        sParameterName,
        i;

    for (i = 0; i < sURLVariables.length; i++) {
        sParameterName = sURLVariables[i].split('=');

        if (sParameterName[0] === sParam) {
            return sParameterName[1] === undefined ? true : decodeURIComponent(sParameterName[1]);
        }
    }
};

function myFunction() {
  var copyText = document.getElementById("myInput");
  copyText.type = 'text';
  copyText.select();
  copyText.setSelectionRange(0, 99999);
  document.execCommand("copy");
  copyText.type = 'hidden';
  
  var tooltip = document.getElementById("myTooltip");
  tooltip.innerHTML = "Copied";
}

function outFunc() {
  var tooltip = document.getElementById("myTooltip");
  tooltip.innerHTML = "Click to Copy";
}

function BlogmyFunction(number) {
  var width = $(window).width();
      
  var curr_url = $('#blogmyInput'+number).val();
  var title = $('#blogmyInput'+number).attr('data-title');

  if(width<=1024){
    if (navigator.share) {
        navigator.share({
            title: title,
            text: '',
            url: curr_url,
        }).then(() => {
            // Any successful share logic goes here
        }).catch((error) => {
            // Handle any error that crops up
        });
  	}
  } else{
    var copyText = document.getElementById("blogmyInput"+number);
    copyText.type = 'text';
    copyText.select();
    copyText.setSelectionRange(0, 99999);
    document.execCommand("copy");
    copyText.type = 'hidden';

    var tooltip = document.getElementById("blogmyTooltip"+number);
    tooltip.innerHTML = "Copied";
  }
}

function BlogoutFunc(number) {
  var tooltip = document.getElementById("blogmyTooltip"+number);
  tooltip.innerHTML = "Click to Copy";
}

  // Get the modal
var modal = document.getElementById("myModal");

// Get the button that opens the modal
var btn = document.getElementById("systemReqModal");

if(btn!=null){
  // Get the <span> element that closes the modal
  var span = document.getElementsByClassName("tz-close")[0];

  // When the user clicks on the button, open the modal
  btn.onclick = function() {
    $('body').addClass('tz-modal-open');

    setTimeout(function(){ 
      modal.style.display = "block";      	  
    }, 500);
  }

  // When the user clicks on <span> (x), close the modal
  span.onclick = function() {
    $('body').removeClass('tz-modal-open');
    modal.style.display = "none";    
  }
}

// When the user clicks anywhere outside of the modal, close it
window.onclick = function(event) {
  if (event.target == modal) {
    $('body').removeClass('tz-modal-open');
    modal.style.display = "none";    
  }
}

$(window).load(function() {
  
  setTimeout(function(){ 
      $('.boost-pfs-filter-button.boost-pfs-filter-clear-all').trigger('click');        
	  $('.template-collection .product_list').css('opacity',1);    	
  }, 100); 

});

/* ==== for recaptach ==== */
var onCaptchaSuccess = function (response) {  
  $('.template-captcha .main-content form').submit();  
  $('.template-captcha .main-content form .shopify-challenge__button').prop("disabled", true);  
};

$(document).ready(function () {
  
  	/* ==== for wishlist ==== */
  	var pr_vari_id = [];
  	$('body .header-right li.open_desktop_wishlist,body .header-right-mobile li.open_mobile_wishlist').click(function () {
		pr_vari_id = [];	
      	$('.cm-wishlist-button a').trigger('click'); 
      	$('.popup .popup-wishlist__content .popup-wishlist__items').trigger('change'); 
	});  
  	
  	$('.popup .popup-wishlist__content .popup-wishlist__items').bind('DOMSubtreeModified', function () {      
      $( ".popup .popup-wishlist__content .popup-wishlist__items .product-store-lists" ).each(function( index ) {
  			var product_variant_id = $(this).attr('data-product-variant-id');    
        	
	        var index = pr_vari_id.indexOf(product_variant_id);        	
            if(index==-1){

              	var priceis = $(this).find('.product-store-lists__content').find('.product-store-lists__price').find('span').html();
      			var priceis_change = priceis.replace("$", "&pound;");        
      			$(this).find('.product-store-lists__content').find('.product-store-lists__price').find('span').html(priceis_change);              
				pr_vari_id.push(product_variant_id);
            }        	
	  });      
	});
  
  	$('body').on('click', '.popup.active', function() {    	                            
      if (!$(event.target).closest('.popup-wishlist').length) {
		pr_vari_id = [];
  	  }
    });  
  
  	$('body').on('click', '.popup .product-store-lists__content .product-store-lists__remove', function() {
    	pr_vari_id = [];
      	$('.popup .popup-wishlist__content .popup-wishlist__items').trigger('change');
	});
  	/* ==== for wishlist ==== */
  
	$('.banner-slider').owlCarousel({
		loop: true,
		margin: 0,
		autoplay: true,
		autoplayTimeout: 5000,
		autoplayHoverPause: false,
		responsiveClass: true,
		nav: false,
		dots: true,
		//navText: ["<img src='https://cdn.shopify.com/s/files/1/0254/1456/5976/files/left.png?v=1598616492'>","<img src='https://cdn.shopify.com/s/files/1/0254/1456/5976/files/right.png?v=1598616515'>"],
		responsive: {
			0: {
				items: 1,
               	autoHeight: true,
			},
			600: {
				items: 1,
			},
			1000: {
				items: 1,
			}
		}
	});
  	$('.banner-right-slider').owlCarousel({
		loop: true,
		margin: 0,
		autoplay: true,
		autoplayTimeout: 6000,
		autoplayHoverPause: false,
		responsiveClass: true,
		nav: false,
		dots: true,
		//navText: ["<img src='https://cdn.shopify.com/s/files/1/0254/1456/5976/files/left.png?v=1598616492'>","<img src='https://cdn.shopify.com/s/files/1/0254/1456/5976/files/right.png?v=1598616515'>"],
		responsive: {
			0: {
				items: 1,
               	autoHeight: true,
			},
			600: {
				items: 1,
			},
			1000: {
				items: 1,
			}
		}
	});
    $('.banner-right-slider-mobile').owlCarousel({
      loop: true,
      margin: 0,
      items: 1,
      autoplay: true,
      autoplayTimeout: 6000,
      autoplayHoverPause: false,
      responsiveClass: true,
      nav: false,
      dots: false,
    });
  
	$('.rgb_slider').owlCarousel({
		loop: true,
		center: false,
		margin: 30,
		autoplay: true,
		autoplayTimeout: 5000,
		autoplayHoverPause: false,
		responsiveClass: true,
		nav: false,
		//navText: ["<img src='https://cdn.shopify.com/s/files/1/0254/1456/5976/files/left.png?v=1598616492'>","<img src='https://cdn.shopify.com/s/files/1/0254/1456/5976/files/right.png?v=1598616515'>"],
		responsive: {
			0: {
				items: 2,
				dots: true,
				margin: 0,
				center: false,
			},
			600: {
				items: 2,
				dots: true,
				center: false,
			},
			1000: {
				items: 5,
			}
		}
	});
	$('.blog-slider').owlCarousel({
		loop: false,
		margin: 0,
		autoplay: true,
		autoplayTimeout: 10000,
		autoplayHoverPause: false,
		responsiveClass: true,
		nav: false,
		dots: true,
		//navText: ["<img src='https://cdn.shopify.com/s/files/1/0254/1456/5976/files/left.png?v=1598616492'>","<img src='https://cdn.shopify.com/s/files/1/0254/1456/5976/files/right.png?v=1598616515'>"],
		responsive: {
			0: {
				items: 1,
			},
			600: {
				items: 1,
			},
			1000: {
				items: 1,
			}
		}
	});
	$('.home-infobox').owlCarousel({
		loop: false,
		margin: 0,
		autoplay: false,
		autoplayTimeout: 5000,
		autoplayHoverPause: false,
		responsiveClass: true,
		nav: false,
		dots: false,
		//navText: ["<img src='https://cdn.shopify.com/s/files/1/0254/1456/5976/files/left.png?v=1598616492'>","<img src='https://cdn.shopify.com/s/files/1/0254/1456/5976/files/right.png?v=1598616515'>"],
		responsive: {
			0: {
				items: 1,
				autoplay: true,
				dots: true,
			},
			600: {
				items: 3,
			},
			1000: {
				items: 3,
			}
		}
	});
	$('.home_plist').owlCarousel({
		loop: true,
		margin: 0,
		autoplay: false,
		autoplayTimeout: 5000,
		autoplayHoverPause: false,
		responsiveClass: true,
		nav: false,
		dots: true,
		//navText: ["<img src='https://cdn.shopify.com/s/files/1/0254/1456/5976/files/left.png?v=1598616492'>","<img src='https://cdn.shopify.com/s/files/1/0254/1456/5976/files/right.png?v=1598616515'>"],
		responsive: {
			0: {
				items: 3,
				autoplay: false,
				dots: true,
              	margin: 10,
              	loop: false,
			},
			600: {
				items: 3,
				autoplay: false,
				dots: true,
			},
			1000: {
				items: 3,
			}
		}
	});
	$('.gameplay').owlCarousel({
		loop: false,
		margin: 30,
		autoplay: false,
		autoplayTimeout: 5000,
		autoplayHoverPause: false,
		responsiveClass: true,
		nav: true,
		dots: false,
		navText: ['<i class="fa fa-caret-left" aria-hidden="true"></i>', '<i class="fa fa-caret-right" aria-hidden="true"></i>'],
		responsive: {
			0: {
				items: 1,
				autoplay: true,
				dots: true,
				nav: false,
			},
			600: {
				items: 3,
			},
			1000: {
				items: 3,
			}
		}
	});
  
    $('.tz_product-single__thumbnails').owlCarousel({
      loop: true,
      margin: 0,
      items: 4,
      autoplay: false,
      autoplayTimeout: 6000,
      autoplayHoverPause: false,
      responsiveClass: true,
      nav: true,
      navText: ['<i class="fa fa-chevron-left" aria-hidden="true"></i>', '<i class="fa fa-chevron-right" aria-hidden="true"></i>'],
      dots: false,
      onInitialized : onInitializedCarousel
    });
  
    function onInitializedCarousel(){
		$('.tz_product-single__thumbnails').css('opacity','1');
    }


/* ================ Common - start ================ */
var window_width = $(window).width();

// $(document).on('show.bs.modal', '.modal', function () {        
//     setTimeout(function() {
//       $('.modal-backdrop:first').remove();
//     }, 100);
// });
  
// $('body').on('click', '.modal-backdrop', function() {
//    $('body #systemReqModal').modal('hide');
// });  

//   $('body').on('click', '.template-product .mshare', function() {  
//     alert(0);
//   });  
  
$('body').on('click', '.template-product .mpdetail_share.only_mobile', function() {  
// $('body .template-product .mpdetail_share').click(function () {
  var curr_url = window.location.href;
  var title = $(this).attr('data-title');  
  
  if (navigator.share) {
        navigator.share({
            title: title,
            text: '',
            url: curr_url,
        }).then(() => {
            // Any successful share logic goes here
        }).catch((error) => {
            // Handle any error that crops up
        });
  }
});
  
$('body .open_dsearch').click(function () {
	$('.desktop_search').toggleClass('active');  
  
    if($('.desktop_search').hasClass('active')){
		$('.desktop_search').fadeIn();
    }else{
    	$('.desktop_search').fadeOut();
    }  	  
});
  
$('body .desktop_search .go_btn').click(function () {  
  var getUrl = window.location.origin;
	var sword = $('body .desktop_search input').val();
	if (sword == "" || sword == null) {
		return false;
	}
	var search_url = getUrl + '/search?q=' + sword;
	window.location.href = search_url;
});

$('body .desktop_search input').on('keypress', function (e) {
	if (e.which == 13) {
		$('body .desktop_search .go_btn').trigger('click');
	}
});
  
$(document).click(function(e){

    if( $(e.target).closest(".desktop_search").length > 0 ) {
      return false;
    }
  	if( $(e.target).closest(".header-right li.pos_rel").length > 0 ) {
      return false;
    }
  
  	if($('.desktop_search').hasClass('active')){
      	$('.desktop_search').removeClass('active');
		$('.desktop_search').fadeOut();
    }    
    
});
  

/* ================ Common - end ================ */

/* ================ Login page - start ================ */
$('body #HideRecoverPasswordLink').click(function () {
	$('.loginpage .grid__item').addClass('medium-up--two-thirds');
	$('.loginpage .grid__item').addClass('medium-up--push-two-twelfths');
	$('.login_footer').show();
});
$('body #RecoverPassword').click(function () {
	$('.loginpage .grid__item').removeClass('medium-up--two-thirds');
	$('.loginpage .grid__item').removeClass('medium-up--push-two-twelfths');
	$('.login_footer').hide();
});
var origin   = window.location.origin;
var pathname = window.location.pathname;
var curr_url = window.location.href;
var lastItem = curr_url.split("/").pop();
if (lastItem == "login#recover") {
	$('body #RecoverPassword').trigger("click");
}
/* ================ Login page - start ================ */
/* ================ Cart page - start ================ */
$('.template-cart .discount_code_box').bind('DOMSubtreeModified', function () {
	var html = $(this).find('.after_discount_price').text();
	var price_only = html.replace("Total", "");
	if (price_only.length > 0) {
		$('.template-cart .tz-cart-subtotal .footer_total .value').html(price_only);
	}
});  

/* ================ Cart page - start ================ */
/* ================ Blog list page - start ================ */
$('.all_blogs .searchbar i.fa-chevron-right').click(function () {
	var getUrl = window.location.origin;
	var sword = $('.all_blogs .searchbar input').val();
	if (sword == "" || sword == null) {
		return false;
	}
	var search_url = getUrl + '/search?q=' + sword;
	window.location.href = search_url;
});
$('.all_blogs .searchbar input').on('keypress', function (e) {
	if (e.which == 13) {
		$('.all_blogs .searchbar i.fa-chevron-right').trigger('click');
	}
});
/* ================ Blog list end - start ================ */
/* ================ Product list page - start ================ */
$('.template-collection .view_type li').click(function () {
	$('.template-collection .view_type li').removeClass('active');
	$(this).addClass('active');
	var type = $(this).attr('data-id');
	if (type == "grid") {
		$('.template-collection .list-view-items').addClass('hide');
		$('.template-collection .grid--view-items').removeClass('hide');
	} else if (type == "list") {
		$('.template-collection .grid--view-items').addClass('hide');
		$('.template-collection .list-view-items').removeClass('hide');
	}
});
$('.template-collection .product_sidebar .sidesearch input').on('keypress', function (e) {
	if (e.which == 13) {
		$('.template-collection .product_sidebar .sidesearch i').trigger('click');
	}
});
$('.template-collection .product_sidebar .sidesearch i').click(function () {
	var getUrl = window.location.origin;
	var sword = $('.template-collection .product_sidebar .sidesearch input').val();
	if (sword == "" || sword == null) {
		return false;
	}
	var search_url = getUrl + '/search?q=' + sword;
	window.location.href = search_url;
});
  
var curr_page = $('input[name="curr_page"]').val();
if (curr_page == "collection") {
	$(function () {
		$("#slider-range").slider({
			range: true,
			min: 0,
			max: 500,
			values: [75, 300],
			slide: function (event, ui) {
				var from = "&pound;" + ui.values[0];
				var to = "&pound;" + ui.values[1];
				var final = from + ' - ' + to;
				$(".price_filter #rangeamount span").html(final);
			}
		});
		var from = "&pound;" + $("#slider-range").slider("values", 0);
		var to = "&pound;" + $("#slider-range").slider("values", 1);
		var final = from + ' - ' + to;
		$(".price_filter #rangeamount span").html(final);
	});
}
  
$('.template-collection .plist_grid_view li').click(function () {
  	$('.template-collection .plist_grid_view li').removeClass('active');
  	$(this).addClass('active');
  
  	var getUrl = window.location.origin;
  
  	var gridurl = getUrl+pathname;
  	var listurl = getUrl+pathname+"?_=pf&display=list";
  
//   	var gridurl = getUrl+"/collections/all";
//   	var listurl = getUrl+"/collections/all?_=pf&display=list";
  
  	var view = $(this).attr('id');
    if(view=="list"){
		window.location.href = listurl;
    }else if(view=="grid"){
		window.location.href = gridurl;
    }
});
  
var product_view = getUrlParameter('display'); 
if(product_view=="list"){
	$('.template-collection .plist_grid_view li').removeClass('active');
  	$('.template-collection .plist_grid_view li#list').addClass('active');
}
  
/* ================ Product list page - end ================ */
/* ================ For mobile menu - start ================ */

if(window_width<=767){  
  /* check for product details page mobile only */  
  if($('body').hasClass('template-product')){
    var heightis = $('.template-product .mobile_ptitle_price').outerHeight();    
    if(heightis>=108){
      $('.template-product .tab_bar').css('top',155);
      $('.template-product .main-content').css('padding-top',144);      
    } else if(heightis>=88){
      $('.template-product .tab_bar').css('top',139);
      $('.template-product .main-content').css('padding-top',128);      
    }else if(heightis>52){
      $('.template-product .tab_bar').css('top',118);
      $('.template-product .main-content').css('padding-top',114);      
    }else{
      $('.template-product .tab_bar').css('top',102);
    }    
    
    setTimeout(function(){ 
    	$('.template-product .tab_bar').css('opacity','1');
    }, 1000);
  }
}
  
$('body .goto_mobile_search').click(function () {   
  
	$('.header .mobile_searchbar').toggleClass('hide');
	$('.template-product .mobile_ptitle_price').toggleClass('search_open');
  	$('.template-product .tab_bar').toggleClass('search_open');
  
  	var heightis = $('.template-product .mobile_ptitle_price').outerHeight();
  
    if($('.template-product .tab_bar').hasClass('search_open')){            	      	      	      
        if(heightis>52){
           $('.template-product .tab_bar').css('top',170);
        }else{
        	$('.template-product .tab_bar').css('top',157);
        }      		
    }else{      	
        if(heightis>52){
			$('.template-product .tab_bar').css('top',118);
        }else{
        	$('.template-product .tab_bar').css('top',102);
        }    	
    }
});
$('.header .mobile_searchbar .go_btn').click(function () {
	var getUrl = window.location.origin;
	var sword = $('.header .mobile_searchbar input').val();
	if (sword == "" || sword == null) {
		return false;
	}
	var search_url = getUrl + '/search?q=' + sword;
	window.location.href = search_url;
});
$('.header .mobile_searchbar input').on('keypress', function (e) {
	if (e.which == 13) {
		$('.header .mobile_searchbar .go_btn').trigger('click');
	}
});
$('[data-toggle="slide-collapse"]').on('click', function () {
	$navMenuCont = $($(this).data('target'));
	$navMenuCont.animate({
		'width': 'toggle'
	}, 350);
	$(".menu-overlay").fadeIn(500);  	
  
  	$('#trustpilot-widget-trustbox-0-wrapper .trustpilot-widget').css('z-index','');
  	$('#trustpilot-widget-trustbox-0-wrapper .trustpilot-widget').css('z-index',99);
  	console.log('yes');
});
$(".menu-overlay").click(function (event) {
	var width = $(window).width();
	if (width >= 768 && width <= 991) {
		$(".navbar-toggle-tab").trigger("click");
	} else {
		$(".navbar-toggle").trigger("click");
	}
	$(".menu-overlay").fadeOut(500);
});
$('.tz-mobile-menu ul li a.dropdown-toggle').on('click', function (e) {
	$('.tz-mobile-menu ul li a.dropdown-toggle').removeClass('open');
	if ($(this).next().css("display") == "block") {
		$(this).next().hide();
		$(this).removeClass('open');
	} else {
		$('.tz-mobile-menu ul li .dropdown-menu').hide();
		$(this).next().show();
		$(this).addClass('open');
	}
});
/* ================ For mobile menu - end ================ */
/* ================ Product Detail page - start ================ */


$(".template-product .bs-example .collapse.show").each(function () {
	$(this).prev(".template-product .bs-example .card-header").find(".fa").addClass("fa-minus").removeClass("fa-plus");
});

$(".template-product .bs-example .collapse").on('show.bs.collapse', function () {
	$(this).prev(".template-product .bs-example .card-header").find(".fa").removeClass("fa-plus").addClass("fa-minus");
}).on('hide.bs.collapse', function () {
	$(this).prev(".template-product .bs-example .card-header").find(".fa").removeClass("fa-minus").addClass("fa-plus");
});
  
$(".template-product .bs-example-main .collapse.show").each(function () {
	$(this).prev(".template-product .bs-example-main .card-header").find(".fa").addClass("fa-minus").removeClass("fa-plus");
});

$(".template-product .bs-example-main .collapse").on('show.bs.collapse', function () {
	$(this).prev(".template-product .bs-example-main .card-header").find(".fa").removeClass("fa-plus").addClass("fa-minus");
}).on('hide.bs.collapse', function () {
	$(this).prev(".template-product .bs-example-main .card-header").find(".fa").removeClass("fa-minus").addClass("fa-plus");
});
  
  if(window_width<=767){
  	$('.template-product .bs-example-main .card-header .btn-link').addClass('collapsed');
    $('.template-product .bs-example-main .collapse').removeClass('show');    
    $('.template-product .bs-example-main .accordion .fa').removeClass('fa-minus');
    $('.template-product .bs-example-main .accordion .fa').addClass('fa-plus');
    
    $(".template-product .bs-example-main #collapseOne").addClass('show');
    $(".template-product .bs-example-main #collapseTwo").addClass('show');
  }  
  
$('.template-product .bs-example-main .card-header').on('click', function (e) {
  
  	if(window_width<=767){
      var pclass = $(this).parent().parent().parent().attr('class');
      
      var goto = $(this).attr('id');
      
      if(pclass!="bs-example"){
        setTimeout(function(){ 
          var ptop = $('.template-product #'+goto).offset().top;
          ptop = ptop - 135
          var body = $("html, body");
          body.stop().animate({
              scrollTop: ptop
          }, 800, 'swing', function () {});
      	}, 500);        
      }

    }
  	
});  

  
$('.template-product .tab_bar ul li a').on('click', function (e) {
	var classname = $(this).attr('data-class');
	var top = $('.' + classname).offset().top;
  	
	if (!$('.template-product .tab_bar').hasClass('fixed')) {
		top = parseInt(top) - 50;
	} else {}
  
  
    top = parseInt(top) - 48;	
  
	var body = $("html, body");
	body.stop().animate({
		scrollTop: top
	}, 800, 'swing', function () {});
});
  
/* for mobile */  
$('.template-product .tab_bar .table-responsive tr td a').on('click', function (e) {  
  var classname = $(this).attr('data-class');
  var first = classname.substring(0, 1);
  
  if(first=="#"){    
  	$('.template-product .bs-example-main '+classname+' button').trigger("click");
  }else{
    $('.template-product .bs-example-main .card-header .btn-link').addClass('collapsed');
    $('.template-product .bs-example-main .collapse').removeClass('show');    
    $('.template-product .bs-example-main .accordion .fa').removeClass('fa-minus');
    $('.template-product .bs-example-main .accordion .fa').addClass('fa-plus');
  }
  
  var top = $(classname).offset().top;    
  
  top = parseInt(top) - 130;	  
  
  var body = $("html, body");
  body.stop().animate({
    scrollTop: top
  }, 800, 'swing', function () {});
    
  
});
  
var isscroll = 0;
if ($(".template-product .product_features").length > 0) {
	var hieghtThreshold = $(".template-product .product_features").offset().top;
	isscroll = 1;
} else if ($(".template-product .tab_bar").length > 0) {
	var hieghtThreshold = $(".template-product .tab_bar").offset().top;
	isscroll = 1;
}
if (isscroll == 1) {
	$(window).scroll(function () {
		var scroll = $(window).scrollTop();
      	
      if(window_width>=768){
        if (scroll >= hieghtThreshold) {
			$('.template-product .tab_bar').addClass('fixed');
		} else {
			$('.template-product .tab_bar').removeClass('fixed');
		}
      }else{
      	$('.template-product .tab_bar').removeClass('fixed');
      }
		
	});
}
$('.template-product .qtybox .btnqty').on('click', function () {
	var qty = parseInt($(this).parent('.qtybox').find('.quantity-input').val());
	if ($(this).hasClass('qtyplus')) {
		qty++;
	} else {
		if (qty > 1) {
			qty--;
		}
	}
	qty = (isNaN(qty)) ? 1 : qty;
	$(this).parent('.qtybox').find('.quantity-input').val(qty);
	$('.template-product .product-form__controls-group .product-form__item input[name="quantity"]').val(qty);
});
$(window).scroll(function () {
	var width = $(window).width();
	if (width <= 767) {
		var sticky = $('.container.header'),
			scroll = $(window).scrollTop();
		if (scroll >= 100) {
			sticky.addClass('fixed');
		} else {
			sticky.removeClass('fixed');
		}
	} else {
		$('.container.header').removeClass('fixed');
	}
});
  
$('.template-product .add_games_carousel').owlCarousel({
    loop: false, 
    margin: 30,
    autoplay: false,
    autoplayTimeout: 5000,
    autoplayHoverPause: false,
    responsiveClass: true,
    nav: false,
    dots: false,
    responsive: {
      0: {
        items: 1,
        stagePadding: 50,
        margin: 0,
      },
      600: {
        items: 3,

      },
      1000: {
        items: 4,
      }
    }
});  

if(window_width<=767){
  
    var product_img_slider = $('.pdetail_images_sub_mob');
  	product_img_slider.on('initialized.owl.carousel', function(event){ 
      $('.pdetail_images_sub_mob').css('opacity',1);
  	});
    product_img_slider.owlCarousel({
        loop: false,
        margin: 0,
       	items: 1,
        autoplay: false,
        autoplayTimeout: 5000,
        autoplayHoverPause: false,
        responsiveClass: true,
        nav: true,
        dots: false,
    });
  
  var mobile_product_variant = 0;
  if($('body').hasClass('template-product')){
  	mobile_product_variant = $('input[name="mobile_product_variant"]').val();
    
    var newslideid = 0;
    $('.pdetail_images_sub_mob .owl-item').each(function(index, value) {
      var data_variantids = $(this).find('.mitem').attr('data-variantids');
      var data_variantids_arr_int = [];

      if(data_variantids!=""){
        if(typeof data_variantids!='undefined'){
          var data_variantids_arr = data_variantids.split(",");
          
          var i;
          for (i = 0; i < data_variantids_arr.length; i++) {
            if(data_variantids_arr[i]!=""){
              	var itemis = data_variantids_arr[i];                 	
              	itemis = itemis.replace(" ", "");
              	data_variantids_arr_int.push(itemis);                            	
            }
          }                   
          
          var thisindex = data_variantids_arr_int.indexOf(mobile_product_variant);    
          
          if(thisindex>=0){              	
            newslideid = $(this).find('.mitem').attr('id');            
          }

        }
      }
    });    

    
    if(newslideid>0){
      product_img_slider.trigger('to.owl.carousel', [newslideid, 100]);    
    }
    
  }       
  
  $(".template-product .single-option-selector").bind("change", function() { 
      mobile_product_variant = getUrlParameter('variant');   

      var newslideid = 0;
      $('.pdetail_images_sub_mob .owl-item').each(function(index, value) {
          var data_variantids = $(this).find('.mitem').attr('data-variantids');
          var data_variantids_arr_int = [];

          if(data_variantids!=""){
            if(typeof data_variantids!='undefined'){
              var data_variantids_arr = data_variantids.split(",");

              var i;
              for (i = 0; i < data_variantids_arr.length; i++) {
                if(data_variantids_arr[i]!=""){
                  var itemis = data_variantids_arr[i];                 	
                  itemis = itemis.replace(" ", "");
                  data_variantids_arr_int.push(itemis);                            	
                }
              }                   

              var thisindex = data_variantids_arr_int.indexOf(mobile_product_variant);    
			 
              if(thisindex>=0){              	
                newslideid = $(this).find('.mitem').attr('id');                 
              }

            }
          }
      });    
          
      
      product_img_slider.trigger('to.owl.carousel', [newslideid, 100]);    
      

    });     
     
  
  setTimeout(function(){
    
    $('.template-product .pdetail_images').css('min-height','auto');    
    
    var total = $('.product-img-slider .owl-dot').length;
	var last = total - 1;    
    var last_second = total - 2;            
  
        
  }, 1000);
 
} 
  
  $(".template-product .single-option-selector").bind("change", function() { 
    var qty = $('.template-product .variant-inventory-main .variant-inventory').val();
    if(qty>0){
    	$('.template-product .variant-inventory-main .dot').removeClass('red');      	
      	$('.template-product .variant-inventory-main .text').text('In Stock');
      
      	$('.template-product .mstock_details .sku_sub .dot').removeClass('red');      	
      	$('.template-product .mstock_details .sku_sub .text').text('In Stock');
      
      	$('.template-product .buy_btn').removeClass('hide');
    }else{
    	$('.template-product .variant-inventory-main .dot').addClass('red');
      	$('.template-product .variant-inventory-main .text').text('Out of Stock');
      
      	$('.template-product .mstock_details .sku_sub .dot').addClass('red');
      	$('.template-product .mstock_details .sku_sub .text').text('Out of Stock');
      
      	$('.template-product .buy_btn').addClass('hide');
    }        
  });  

$('.template-product .buy_btn').click(function () {
    
  var top_pd = $('.template-product .mpayment_info').offset().top;    
  
  top_pd = parseInt(top_pd) - 200;	  
  
  var body = $("html, body");
  body.stop().animate({
    scrollTop: top_pd
  }, 800, 'swing', function () {});
  
  $('.template-product .mproduct_footer .btn.product-form__cart-submit').trigger("click");
});
  

$('.gameplay .item .btns p a').removeAttr('target');

// $( ".gameplay .item .btns p a").each(function( index ) {  
// 	var thisurl = $(this).attr('href');
//     if(thisurl==""){
//       $(this).attr('href','javascript:;');
//     }
// });  
  
// $('.gameplay .item .btns p a[href!="javascript:;"]').fancybox({
	
// });
  
  
  var height_get = $('.gameplay .item .bgimg').outerHeight(true);
  var print_height = height_get + 24;

  $( ".gameplay .item").each(function( index ) {  
    $(this).children('.bgimg').append('<iframe class="iframe" src="" width="100%" height="0" frameBorder="0" webkitallowfullscreen mozallowfullscreen allowfullscreen></iframe>');
  });


  function getId(url) {
    var pattern1 = /(?:http?s?:\/\/)?(?:www\.)?(?:vimeo\.com)\/?(.+)/g;
    var pattern2 = /(?:http?s?:\/\/)?(?:www\.)?(?:youtube\.com|youtu\.be)\/(?:watch\?v=)?(.+)/g;

    if(pattern1.test(url)){
      var replacement = '//player.vimeo.com/video/$1';
      var html = url.replace(pattern1, replacement);
    }
    if(pattern2.test(url)){
      var replacement = 'http://www.youtube.com/embed/$1';
      var html = url.replace(pattern2, replacement);
    }
    return html;
  }

  $('.gameplay .item .btns p a').click(function(e) {
    var selected = $(this).attr('href');


    if(selected != ""){      
      const videoId = getId(selected);

      $('.iframe').each(function(index) {
        $(this).attr('src', $(this).attr('src'));
      });

      $(this).parent().parent().parent().find('iframe').attr("src",videoId);
      $(this).parent().parent().parent().find('.bgimg').css("padding-top","0");	
      $(this).parent().parent().parent().find('.bgimg').css("background","transparent");
      $(this).parent().parent().parent().find('iframe').attr("height",print_height);
      $('.gameplay .item .btns p').css("background","#e50019");
      $('.gameplay .item .btns a').css("color","#ffffff");
      $(this).parent().css("background","#ffffff");
      $(this).css("color","#e50019");

      e.preventDefault();
    }

    e.preventDefault();
  });
  
  
/* ================ Product Details page - end ================ */
  
/* ================ Password reset page - start ================ */
  $('.template-customers-reset_password form .btn.btn-red.text-center').on('click', function () {
    var password = $('.template-customers-reset_password form #ResetPassword').val();
    var cpassword = $('.template-customers-reset_password form #PasswordConfirmation').val();
    
    $('.template-customers-reset_password form .reset_pass_error').addClass('hide');
    
    if(password!=cpassword){
      	$('.template-customers-reset_password form .reset_pass_error').removeClass('hide');
    	return false;
    }    
    
  });     

/* ================ Password reset page - end ================ */      
  
});


var access_token = '4144597d720124e5bdfd1ecdd7de9fc53db3954fd660f00cd6fb5e46d0bd9190';

// $('.page_support .support_form #support_subject').val('');
$('.page_support .support_form #support_desc').val('');
$('.page_support .support_form #support_type').val('-');
// $('.page_support .support_form #support_cname').val('');
$('.page_support .support_form #support_cemail').val('');
$('.page_support .support_form #support_oid').val('');
$(".page_support .support_form #support_file").val(null);

function create_user(email,name){
  
    var support_form_validation_test = support_form_validation();
    if(support_form_validation_test==1){
      return false;
    }   

  	var user_params = {};
  	user_params['name'] = name;
    user_params['email'] = email;
    user_params['role'] = 'end-user';
    user_params['verified'] = true;
  
    let user_params_main = JSON.stringify({
      user: user_params,
    });

    var request_create_user = new XMLHttpRequest();

    request_create_user.onreadystatechange = function() {
      if (request_create_user.readyState === 4) {
        if (request_create_user.status === 200) {
          
        } else if (request_create_user.status === 201) {
          
          var data = JSON.parse(request_create_user.responseText);          
          
          if(data.user!=""){
            var userid = data.user['id'];
            create_ticket(userid);
          }else{
            $('.template-page .support_form .support_form_error').html('Details has been not been sent, please try again.');            
            $('.template-page .submit_ticket').prop('disabled', false);
          }
          
        } else {
          $('.template-page .support_form .support_form_error').html('Details has been not been sent, please try again.');
          $('.template-page .submit_ticket').prop('disabled', false);
        }
      }
    };

    var url = 'https://veno-scorp.zendesk.com/api/v2/users.json';
    request_create_user.open('POST', url, true);
    request_create_user.setRequestHeader("Authorization", "Bearer " + access_token);
    request_create_user.setRequestHeader('Content-type', 'application/json; charset=utf-8');
    request_create_user.send(user_params_main);
}

function randomString(length) {
    return Math.round((Math.pow(36, length + 1) - Math.random() * Math.pow(36, length))).toString(36).slice(1);
}

function create_ticket(requester_id){
  var support_form_validation_test = support_form_validation();
  if(support_form_validation_test==1){
  	return false;
  }
  
  var request = new XMLHttpRequest();

  request.onreadystatechange = function() {
    if (request.readyState === 4) {
      if (request.status === 200) {
        
      } else if (request.status === 201) {      	
        
        $('.template-page .submit_ticket').prop('disabled', false);
        
        $('.template-page .support_form .support_form_error').html('Details has been sent.');
  	    $('.template-page .support_form .support_form_error').removeClass('red');
        $('.template-page .support_form .support_form_error').addClass('green');
        
//         $('.page_support .support_form #support_subject').val('');
        $('.page_support .support_form #support_desc').val('');
        $('.page_support .support_form #support_type').val('-');
//         $('.page_support .support_form #support_cname').val('');
        $('.page_support .support_form #support_cemail').val('');
        $('.page_support .support_form #support_oid').val('');
        $(".page_support .support_form #support_file").val(null);
        
      } else {
        if (request.status === 0) {
          $('.template-page .support_form .support_form_error').html('Details has been not been sent, please try again.');
          $('.template-page .submit_ticket').prop('disabled', false);
        } else {
          $('.template-page .support_form .support_form_error').html('Details has been not been sent, please try again.');
          $('.template-page .submit_ticket').prop('disabled', false);
        }
      }
    }
  };

//   var subjectis = $('.page_support .support_form #support_subject').val();
//   var subjectis = '-';
  var subjectis = $('.page_support .support_form #support_type').val();
  var desc = $('.page_support .support_form #support_desc').val();
  var typeis = $('.page_support .support_form #support_type').val();
  var orderid = $('.page_support .support_form #support_oid').val();

  var body = {body:desc};
  
  var via = {
    "channel": "api",
  };
  var custom_fields = [
      {
        "id":    360010697657,
        "value": typeis
      },
      {
        "id":    360010658298,
        "value": orderid
      }
  ];

  var tickets = {};
  tickets['subject'] = subjectis;
  tickets['type'] = typeis;
  tickets['requester_id'] = requester_id;
  tickets['via'] = via;
  tickets['custom_fields'] = custom_fields;
  tickets['comment'] = body;  
  
  var valid_for_upload = 0;
  
  if ($('.page_support .support_form #support_file').get(0).files.length > 0) {
        
    var file = document.getElementById('support_file').files[0];    
	var file_type = document.getElementById('support_file').files[0].type;
    var file_size = document.getElementById('support_file').files[0].size;    

    var file_ext = '';
    var isvalid = 0;
    if(file_type=="image/jpeg"){
    	var file_ext = 'jpg';
      	isvalid = 1;
    }else if(file_type=="image/png"){
    	var file_ext = 'png';
      	isvalid = 1;
    }else if(file_type=="application/pdf"){
    	var file_ext = 'pdf';
      	isvalid = 1;
    }else{
    	isvalid = 0;
    }
    
    var filename = randomString(15);
    filename = filename+'.'+file_ext;     
    
    if(isvalid==1){
      valid_for_upload = 1;
    }
    
    if(file_size > 2000000){
      valid_for_upload = 0;
    }
  }  
  
  if(valid_for_upload==1){
    
  	var url = 'https://veno-scorp.zendesk.com/api/v2/uploads.json?filename='+filename;    

    $.ajax({
      url: url,
      type: "POST",
      data: file,
      dataType: "json",
      processData: false,
      contentType: false,
      success: function (data) {
        
        file_token = data.upload.token;    
        
        var body = {body:desc,"uploads":  [file_token]};
        tickets['comment'] = body;
        
        let ticket_main = JSON.stringify({
          ticket: tickets,
        });
    
        var params = ticket_main;
        var url = 'https://veno-scorp.zendesk.com/api/v2/tickets.json';
        request.open('POST', url, true);
        request.setRequestHeader("Authorization", "Bearer " + access_token);
        request.setRequestHeader('Content-type', 'application/json; charset=utf-8');
        request.send(params);        
      },
    });
    
  }else{  
            
    let ticket_main = JSON.stringify({
      ticket: tickets,
  	});
    
    var params = ticket_main;
    var url = 'https://veno-scorp.zendesk.com/api/v2/tickets.json';
    request.open('POST', url, true);
    request.setRequestHeader("Authorization", "Bearer " + access_token);
    request.setRequestHeader('Content-type', 'application/json; charset=utf-8');
    request.send(params);
  }

}

function support_form_validation(){
  var type = $('.page_support .support_form #support_type').val();
  var name = $('.page_support .support_form #support_cname').val();
  var email = $('.page_support .support_form #support_cemail').val();  
//   var subject = $('.page_support .support_form #support_subject').val();
  var desc = $('.page_support .support_form #support_desc').val();  
  var error = 0;
  
  if(type=="-"){
  	$('.template-page .support_form .support_form_error').html('Please select Type');
    error = 1;
    $('.template-page .submit_ticket').prop('disabled', false);
    return error;
  }

  if(name==""){
  	$('.template-page .support_form .support_form_error').html('Please enter Name');
    error = 1;
    $('.template-page .submit_ticket').prop('disabled', false);
    return error;
  }
  
  if(email==""){
  	$('.template-page .support_form .support_form_error').html('Please enter Email');
    error = 1;
    $('.template-page .submit_ticket').prop('disabled', false);
    return error;
  }
  
  if(desc==""){
  	$('.template-page .support_form .support_form_error').html('Please enter Decription');
    error = 1;
    $('.template-page .submit_ticket').prop('disabled', false);
    return error;
  }
  
//   if(subject==""){
//   	$('.template-page .support_form .support_form_error').html('Please enter Subject');
//     error = 1;
//     $('.template-page .submit_ticket').prop('disabled', false);
//     return error;
//   }  

  
  return error;
  
}


$('.template-page .submit_ticket').on('click', function () {  
  
  $('.template-page .support_form .support_form_error').addClass('red');
  
  var support_form_validation_test = support_form_validation();
  if(support_form_validation_test==1){
  	return false;
  }
  
  $('.template-page .submit_ticket').prop('disabled', true);
  $('.template-page .support_form .support_form_error').html('Please wait...');  
  
  var email = $('.page_support .support_form #support_cemail').val();
  var name = $('.page_support .support_form #support_cname').val();

  var request_user_created = new XMLHttpRequest();
    var userid = 0;
    request_user_created.onreadystatechange = function() {
      if (request_user_created.readyState === 4) {
        if (request_user_created.status === 200) {
          var data = JSON.parse(request_user_created.responseText);
          if(data.users!=""){
            var userid = data.users[0]['id'];
            create_ticket(userid);
          }else{            
            create_user(email,name);
          }
        } else {          
          create_user(email,name);
        }
      }else{

      }
    };

    var url = 'https://veno-scorp.zendesk.com/api/v2/users/search.json?query='+email;
    request_user_created.open('GET', url, true);
    request_user_created.setRequestHeader("Authorization", "Bearer " + access_token);
    request_user_created.setRequestHeader('Content-type', 'application/json; charset=utf-8');
    request_user_created.send();
  
});    

// subscription form if email already exists error
if(window.location.pathname=="/"){
	var form_type = getUrlParameter('form_type');
  	var customer_posted = getUrlParameter('customer_posted');
  
    if(form_type=="customer"){
      setTimeout(function(){ 
      
        var width = $(window).width();
        
        if(width>=768){
        
          if(!$('.home-sec-subscribe.only_desktop #ContactFooter .input-group').hasClass('input-group--error')){

            $('.home-sec-subscribe.only_desktop #ContactFooter .input-group').addClass('input-group--error');
            $('.home-sec-subscribe.only_desktop #ContactFooter .input-group .input-group__field').addClass('input--error');
            $('.home-sec-subscribe.only_desktop #ContactFooter .formerror').removeClass('simplehide');

            var fromtop = $('.home-sec-subscribe.only_desktop .newsletter-sec').offset().top;
            var body = $("html, body");
            body.stop().animate({scrollTop:fromtop}, 500, 'swing', function() { 

            });
          }  
          
        } else {
        
          if(!$('.home-sec-subscribe.only_mobile #ContactFooterMobile .input-group').hasClass('input-group--error')){

            $('.home-sec-subscribe.only_mobile #ContactFooterMobile .input-group').addClass('input-group--error');
            $('.home-sec-subscribe.only_mobile #ContactFooterMobile .input-group .input-group__field').addClass('input--error');
            $('.home-sec-subscribe.only_mobile #ContactFooterMobile .formerror').removeClass('simplehide');

            var fromtop = $('.newsletter-sec-mob').offset().top;
            fromtop = parseInt(fromtop) - 50; 
            var body = $("html, body");
            body.stop().animate({scrollTop:fromtop}, 500, 'swing', function() { 

            });
          } else {
          	var fromtop = $('.newsletter-sec-mob').offset().top;
            fromtop = parseInt(fromtop) - 50; 
            var body = $("html, body");
            body.stop().animate({scrollTop:fromtop}, 500, 'swing', function() { 

            });
          }  
          
        }
        
        
      }, 1000);
    }
  
    if(customer_posted=="true"){
		setTimeout(function(){ 
          	var width = $(window).width();
          
            if(width < 768){
              var fromtop = $('.newsletter-sec-mob').offset().top;
              fromtop = parseInt(fromtop) - 50; 
              var body = $("html, body");
              body.stop().animate({scrollTop:fromtop}, 500, 'swing', function() { 

              });
            }
        }, 1000);  
    }
  
}else if(window.location.pathname=="/blogs/news"){
	var form_type = getUrlParameter('form_type');
  	if(form_type=="customer"){
      setTimeout(function(){         
        
        if(!$('#ContactFooterNew .input-group').hasClass('input-group--error')){
          	
        	$('#ContactFooterNew .input-group').addClass('input-group--error');
          	$('#ContactFooterNew .input-group .input-group__field').addClass('input--error');
          	$('#ContactFooterNew .formerror').removeClass('simplehide');
          
          	var fromtop = $('#ContactFooterNew').offset().top;
          	var body = $("html, body");
            body.stop().animate({scrollTop:fromtop}, 500, 'swing', function() { 
               
            });
        }
        
      }, 1000);
    }
}

// Collection Sidebar - Price Range


setTimeout(function(){   

  $('body').on('mousemove', '.boost-pfs-filter-options-wrapper .boost-pfs-filter-option-range-slider .noUi-handle-lower', function() {  
        
    var len = $('.boost-pfs-filter-options-wrapper .boost-pfs-filter-option-range-slider .noUi-handle-lower .noUi-lower-selected').length;
    if(len==0){
    	$('.boost-pfs-filter-options-wrapper .boost-pfs-filter-option-range-slider .noUi-handle-lower').append("<div class='noUi-lower-selected'></div>");      	
    }
    
    var aria_valuenow = $(this).attr('aria-valuenow');
    aria_valuenow = Math.round(aria_valuenow);
    var aria_valuenow_euro = '£'+aria_valuenow;    
    $('.boost-pfs-filter-options-wrapper .boost-pfs-filter-option-range-slider .noUi-handle-lower .noUi-lower-selected').text(aria_valuenow_euro);
    $('.boost-pfs-filter-options-wrapper .boost-pfs-filter-option-range-slider .noUi-handle-lower .noUi-lower-selected').css('opacity','1');
    
  });  
  
  $('body').on('mousemove', '.boost-pfs-filter-options-wrapper .boost-pfs-filter-option-range-slider .noUi-handle-upper', function() {  

    var len = $('.boost-pfs-filter-options-wrapper .boost-pfs-filter-option-range-slider .noUi-handle-upper .noUi-upper-selected').length;
    if(len==0){
      $('.boost-pfs-filter-options-wrapper .boost-pfs-filter-option-range-slider .noUi-handle-upper').append("<div class='noUi-upper-selected'></div>");      
    }

    var aria_valuenow = $(this).attr('aria-valuenow');
    aria_valuenow = Math.round(aria_valuenow);
    var aria_valuenow_euro = '£'+aria_valuenow;    
    $('.boost-pfs-filter-options-wrapper .boost-pfs-filter-option-range-slider .noUi-handle-upper .noUi-upper-selected').text(aria_valuenow_euro);
    $('.boost-pfs-filter-options-wrapper .boost-pfs-filter-option-range-slider .noUi-handle-upper .noUi-upper-selected').css('opacity','1');

  });
  
  $('.boost-pfs-filter-options-wrapper .boost-pfs-filter-option-range-slider .noUi-handle-lower').append("<div class='noUi-lower-selected'></div>");
  $('.boost-pfs-filter-options-wrapper .boost-pfs-filter-option-range-slider .noUi-handle-upper').append("<div class='noUi-upper-selected'></div>");
  
  $('.boost-pfs-filter-options-wrapper .boost-pfs-filter-option-range-slider .noUi-handle-lower .noUi-lower-selected').css('opacity','0');
  $('.boost-pfs-filter-options-wrapper .boost-pfs-filter-option-range-slider .noUi-handle-upper .noUi-upper-selected').css('opacity','0');
  
  
}, 1000);

// RTX collection game video
if($('#rtx_game_video').length > 0){
  var iframe = document.querySelector('#rtx_game_video');
  var player = new Vimeo.Player(iframe);
  $('body').on('click', '.game_video .game_video_sub .overlay', function() {    
    if($(this).hasClass('play')){
      player.pause();  
      $(this).removeClass('play');
      $('.game_video i').css('opacity','1');
    }else{
      player.play();
      $(this).addClass('play');
      $('.game_video i').css('opacity','0');
    }
  });
}

// for collection only
setTimeout(function(){ 
var collection_filter = $('#Collection .boost-pfs-filter-options-wrapper .boost-pfs-filter-option').text();  
  console.log(collection_filter.length);
  if(collection_filter.length==0){
// 	$('header.collection-header').hide();
    $('.boost-pfs-filter-wrapper .boost-pfs-filter-tree').hide();
  }  
}, 1000);



